// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1lXfN","colMin":"styles_colMin__vzAHF","colCheckbox":"styles_colCheckbox__XxLvs"};